import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import CardWrapper from "cards/components/CardWrapper";
import styles from "./MidtermsPromoStreamCap.css";
import { promoInViewDataLayerEvent } from "utils/analytics";
import image from "assets/img/midterms.png";

const data = {
  title: "Get the latest on the midterm elections",
  text:
    "Follow Axios' midterms coverage, including real-time race results and analysis on why they matter.",
  link: "https://axios.com/tag/2018-midterm-elections/",
};

class MidtermsPromoStreamCap extends Component {
  componentDidMount() {
    promoInViewDataLayerEvent("stream_cap_midterms_promo", data);
  }

  render() {
    return (
      <CardWrapper
        className={classNames(styles.root, "gtm-stream-cap-midterms-promo")}
      >
        <div className={styles.content}>
          <h4>
            <Link
              to="/tag/2018-midterm-elections/"
              className={classNames(
                styles.title,
                "gtm-midterms-stream-cap-promo-link"
              )}
            >
              {data.title}
            </Link>
          </h4>
          <p className={styles.paragraph}>{data.text}</p>
        </div>
        <img className={styles.image} src={image} />
      </CardWrapper>
    );
  }
}

export default MidtermsPromoStreamCap;
